import { render, staticRenderFns } from "./AdminContactsView.vue?vue&type=template&id=23d69b26"
import script from "./AdminContactsView.vue?vue&type=script&lang=js"
export * from "./AdminContactsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports